import { z } from 'zod';
import { IdempotencyKeySchema, PlayerIdSchema } from './common.js';

export const HouseBadgeSchema = z.enum(['owned', 'member', 'locked']);

export const HouseListItemSchema = z.object({
  id: z.string(),
  ownerDogName: z.string(),
  badge: HouseBadgeSchema,
  canRequest: z.boolean(),
});

export const HousesListResponseSchema = z.object({
  houses: z.array(HouseListItemSchema),
  page: z.number().int().nonnegative(),
});
export type HousesListResponse = z.infer<typeof HousesListResponseSchema>;

export const HouseEnterResponseSchema = z.object({
  layout: z.unknown(),
  layoutVersion: z.number().int().nonnegative(),
});
export type HouseEnterResponse = z.infer<typeof HouseEnterResponseSchema>;

export const ResidencyRequestSchema = z.object({
  idempotencyKey: IdempotencyKeySchema,
});
export type ResidencyRequest = z.infer<typeof ResidencyRequestSchema>;

export const ResidencyRequestResponseSchema = z.object({
  inviteId: z.string(),
  status: z.enum(['pending', 'accepted', 'declined', 'expired', 'revoked']),
});
export type ResidencyRequestResponse = z.infer<typeof ResidencyRequestResponseSchema>;

export const InvitesPendingResponseSchema = z.object({
  invites: z.array(
    z.object({
      id: z.string(),
      houseId: z.string(),
      requesterPlayerId: PlayerIdSchema,
      requesterDogName: z.string(),
      status: z.literal('pending'),
      createdAt: z.string(),
      expiresAt: z.string(),
    }),
  ),
});
export type InvitesPendingResponse = z.infer<typeof InvitesPendingResponseSchema>;

export const InviteRespondRequestSchema = z.object({
  accept: z.boolean(),
});
export type InviteRespondRequest = z.infer<typeof InviteRespondRequestSchema>;

export const InviteRespondResponseSchema = z.object({
  status: z.enum(['accepted', 'declined']),
});
export type InviteRespondResponse = z.infer<typeof InviteRespondResponseSchema>;

export const LayoutLocationTypeSchema = z.enum(['home', 'stable']);

export const LayoutPutRequestSchema = z.object({
  locationType: LayoutLocationTypeSchema,
  layout: z.unknown(),
  version: z.number().int().nonnegative(),
});
export type LayoutPutRequest = z.infer<typeof LayoutPutRequestSchema>;

export const LayoutPutResponseSchema = z.object({
  version: z.number().int().nonnegative(),
});
export type LayoutPutResponse = z.infer<typeof LayoutPutResponseSchema>;

export const MemberDeleteResponseSchema = z.object({
  ok: z.literal(true),
});
